export default {
  // 页面标题
  title: '模板设置',

  // 搜索筛选区域
  search: {
    // 搜索条件标签
    templateName: '模板名称',
    templateId: '模板ID',
    cloudStorageId: '云存储ID',
    applicableBranch: '适用分公司',
    applicableCompany: '适用公司',
    templateType: '模板归类',

    // 占位符
    placeholder: {
      enterTemplateName: '请输入模板名称',
      enterTemplateId: '请输入模板ID',
      enterCloudStorageId: '请输入云存储ID',
      selectApplicableBranch: '请选择适用分公司',
      selectApplicableCompany: '请选择适用公司',
      selectTemplateType: '请选择模板归类',
      selectTemplateUsage: '请选择模板用途'
    },

    // 按钮
    search: '搜索',
    reset: '重置'
  },

  // 操作按钮区域
  actions: {
    addTemplate: '新增模板',
    batchDelete: '批量删除',
    totalRecords: '共 {count} 条记录'
  },

  // 表格列标题
  table: {
    columns: {
      templateId: '模板ID',
      templateName: '模板名称',
      cloudStorageId: '云存储ID',
      applicableBranch: '适用分公司',
      applicableCompany: '适用公司',
      templateType: '模板归类',
      templateEngine: '模板引擎',
      templateUsage: '模板用途',
      remarks: '备注',
      actions: '操作'
    },

    placeholders: {
      noTemplate: '暂无模板数据'
    },

    // 模板用途标签
    usage: {
      print: '打印',
      email: '邮件'
    },

    // 操作按钮
    actions: {
      edit: '编辑',
      copy: '复制',
      more: '更多',
      config: '配置',
      delete: '删除'
    }
  },

  // 模态框
  modal: {
    title: {
      add: '新增模板',
      edit: '编辑模板'
    },

    // 按钮文本
    okText: '确定',
    cancelText: '取消',

    // 表单字段
    form: {
      templateChineseName: '模板中文名称',
      templateEnglishName: '模板英文名称',
      applicableBranch: '适用分公司',
      applicableCompany: '适用公司',
      templateType: '模板归类',
      templateUsage: '模板用途',
      cloudStorageId: '云存储ID',
      uploadFile: '上传文件',
      uploading: '上传中...',
      remarks: '备注',

      // 占位符
      placeholder: {
        enterTemplateChineseName: '请输入模板中文名称',
        enterTemplateEnglishName: '请输入模板英文名称',
        selectApplicableBranch: '请选择适用分公司',
        selectApplicableCompany: '请选择适用公司',
        selectTemplateType: '请选择模板归类',
        selectTemplateUsage: '请选择模板用途',
        enterCloudStorageId: '请输入云存储ID',
        enterRemarks: '请输入备注'
      }
    }
  },

  // 模板选择对话框
  selection: {
    templateName: '模板名称',
    templateType: '模板类型',
    title: '选择模板',
    searchPlaceholder: '请输入模板名称',
    confirm: '确定',
    cancel: '取消'
  },

  // 确认对话框
  confirm: {
    delete: {
      title: '确认删除',
      content: '确定要删除模板"{name}"吗？此操作不可恢复。',
      batchContent: '确定要删除选中的 {count} 个模板吗？此操作不可恢复。',
      okText: '确认',
      cancelText: '取消'
    }
  },

  // 消息提示
  message: {
    success: {
      create: '模板创建成功',
      update: '模板更新成功',
      delete: '模板删除成功',
      batchDelete: '成功删除 {count} 个模板',
      copy: '模板复制成功',
      config: '已打开报告配置页面',
      upload: '文件上传成功，已自动填充云存储ID'
    },
    error: {
      loadFailed: '数据加载失败，请稍后重试',
      createFailed: '模板创建失败',
      updateFailed: '模板更新失败',
      deleteFailed: '模板删除失败',
      batchDeleteFailed: '批量删除失败',
      operationFailed: '操作失败，请稍后重试',
      copyFailed: '模板复制失败',
      configFailed: '配置模板失败，请稍后重试',
      uploadNoStorageId: '未获取到云存储ID',
      uploadFailed: '文件上传失败，请重试',
      loadOfficeTreeFailed: '组织架构加载失败，请稍后重试'
    },
    warning: {
      noTemplateId: '模板ID不能为空',
      noSelection: '请先选择要删除的模板'
    },
    info: {
      copyNotImplemented: '复制功能待实现',
      configNotImplemented: '配置功能待实现'
    }
  }
}
